document.addEventListener('click', function(e) {

  const btn = e.target.closest('.cart-discount__button');
  if (!btn) return;

  // prevent double click while loading
  if (btn.classList.contains('loading')) return;

  // store original content ONLY once
  if (!btn.dataset.originalText) {
    btn.dataset.originalText = btn.innerHTML;
  }

  btn.classList.add('loading');

  // replace with loader
  btn.innerHTML = `<span class="loader"></span>`;

  setTimeout(() => {
    btn.classList.remove('loading');

    // restore original content
    btn.innerHTML = btn.dataset.originalText;

  }, 2000);

});